import React from 'react'
import { FormProvider } from 'react-hook-form'
import { Table } from '@/app/entities/TableCredit'
import { useCreditClientFormController } from './useCreditClientFormController'
import { PersonalInfoStep } from './components/PersonalInfoStep'
import { AddressStep } from './components/AddressStep'
import { BankInfoStep } from './components/BankInfoStep'
import { ReviewStep } from './components/ReviewStep'
import { StepsProgress } from './components/StepsProgress'
import { formatCpfNumber } from '@/app/utils/cpfFormater'
import { cn } from '@/app/utils/cn'
import { FloatingSellerButton } from '../CreditSellerCard/FloatingSellerButton'

interface CreditClientFormProps {
  cpf: string
  name: string
  birthDate: string
  table: Table
  onBack: () => void
}

const CreditClientForm: React.FC<CreditClientFormProps> = ({
  cpf,
  name,
  birthDate,
  table,
  onBack,
}) => {
  const {
    form,
    step,
    steps,
    banks,
    handleNextStep,
    handlePrevStep,
    handleCepRequest,
    seller,
    handleWhatsAppClick,
  } = useCreditClientFormController()

  return (
    <>
      <div
        className={cn(
          'border-zinc100 mx-auto h-screen max-w-xl border-l border-r',
          steps.review ? 'p-0' : 'p-6',
        )}
      >
        {!steps.review && (
          <div className="mb-6 flex items-center justify-center gap-2 rounded-lg border border-gray01 bg-gray02 py-3 text-center text-sm font-semibold tracking-wide sm:text-lg">
            <p>{formatCpfNumber(cpf)}</p> <p className="uppercase">{name}</p>
          </div>
        )}

        {!steps.review && <StepsProgress currentStep={step} totalSteps={3} />}

        <FormProvider {...form}>
          <PersonalInfoStep
            visible={steps.personalInfo}
            onNext={handleNextStep}
            onBack={onBack}
          />

          <AddressStep
            visible={steps.address}
            onNext={handleNextStep}
            onBack={handlePrevStep}
            onCepRequest={handleCepRequest}
          />

          <BankInfoStep
            visible={steps.bankInfo}
            onNext={handleNextStep}
            onBack={handlePrevStep}
            banks={banks || []}
          />

          <ReviewStep
            visible={steps.review}
            table={table}
            cpf={cpf}
            name={name}
            birthDate={birthDate}
            onBack={onBack}
          />
        </FormProvider>
      </div>

      <FloatingSellerButton
        handleWhatsAppClick={handleWhatsAppClick}
        seller={seller || undefined}
      />
    </>
  )
}

export default CreditClientForm
